import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type {
  ISettingsPaymentSystemsPayload,
} from '../types';
import {
  ADMIN_PAYMENT_SYSTEMS_PERMISSIONS,
  SETTINGS_PAYMENT_SYSTEMS_LIST_QUERY_KEY,
  SETTINGS_PAYMENT_SYSTEMS_REMOVE_MUTATION_KEY,
  SETTINGS_PAYMENT_SYSTEMS_REMOVE_URL,
} from '../constants';

export default function useSettingsPaymentSystemsRemoveMutation(): IContextMutationResult<
  void,
  Error,
  ISettingsPaymentSystemsPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    void,
    Error,
    ISettingsPaymentSystemsPayload
  >({
    mutationKey: [SETTINGS_PAYMENT_SYSTEMS_REMOVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPut<void>(
      SETTINGS_PAYMENT_SYSTEMS_REMOVE_URL,
      payload,
      {
        permission: ADMIN_PAYMENT_SYSTEMS_PERMISSIONS.PAYMENTSYSTEMLISTS_UPDATE,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_PAYMENT_SYSTEMS_LIST_QUERY_KEY] });
      displayPresetToast('removed');
    },
  });
}
